{
  "clubId": "club-user",
  "ticketPrice": 45.0,
  "version": 1,
  "effectiveAt": "2026-10-12T20:00:00Z"
}
